import { OrgPricingResponse } from '@goldcast/api/backend';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const getInitialState = () => ({
  orgPricingConfig: {} as OrgPricingResponse
});

const state = getInitialState();

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
